import { Serializable } from '@core/models';

export class PrintMenuProduct extends Serializable {
  static printCurrency = null;

  static configuration = null;

  lineProductHeight = {
    small: '0px 10px 0px',
    medium: '5px 10px 5px',
    large: '10px 10px 10px',
  }

  featuresSize = {
    small: 15,
    medium: 22,
    large: 30,
  }

  constructor(guid, commercialName, commercialDescription, features, price, special, specialFrame) {
    super();
    this.guid = guid;
    this.commercialName = commercialName;
    this.commercialDescription = commercialDescription;
    this.features = features;
    this.price = price;
    this.special = special;
    this.special_frame = specialFrame;
  }

  serialize() {
    return {};
  }

  formatForHtml() {
    let featuresHtml = '';
    featuresHtml = `<div style="flex: 20%;display:flex; flex-direction:row; flex-wrap: wrap; margin-left: 5px">
          ${this.getFeatures()}
          </div>`;
    const starBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAABFElEQVRIx+3VvUoDURCG4Sf+oVUIKIKVio2FCBYKYm1lq2UaEcTGOp23ICKIpVYW3oWdrd6AGkHBQiyMkqCFuxBD1pw9JpUOfMWeM+f9ZpiB5a/FEhZ7aXCKk17Bx/CKN4yHPurLYbCNYQxhq9vVD+AWH4mqGOymwUYTPNV6yMP+jPMiJjGLBVQw0ZIzjUeMYgR1X/PJjAruUGtTbahqCaPSzqCAvV/AU+3rsDybeI8A17ETOtRVPOeAv2AtFJ7GHG4C4PfJIkTFeYDBWSxcUl0ng2osfCbHDKayID+t03LLdwMHiRotdysxHRw3VXjp+39gHhdN90cxBtd4wm5GpwWU8YCrvPAiDlEKyC0lucWYLv7DJ6/EiAHbCcd3AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTEyLTIwVDA5OjI2OjU4KzAwOjAwTsuBbwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0xMi0yMFQwOToyNjo1OCswMDowMD+WOdMAAAAASUVORK5CYII=';
    const specialStyles = this.special_frame ? 'border: 1px solid black;' : '';
    const specialIcon = this.special ? `<img alt="starIcon" src="${starBase64}" width="15" height="15"/>` : '';
    const html = `
    <li class="product-item">
        <div style="display:flex; flex-direction:column; padding: ${this.lineProductHeight[PrintMenuProduct.configuration.lineProductHeight]}; ${specialStyles}">
            <div style="display:flex; flex-direction:row; width: 100%; flex-wrap: wrap">
                <div style="display: flex; flex: 60%; flex-direction: column;">
                    <span class="secondary-text" style="font-weight: bold;">${this.commercialName}${specialIcon}</span>
                    ${PrintMenuProduct.configuration.showProductDescription ? `<span class="secondary-text" style="margin-left:10px; line-height: 15px;">${this.commercialDescription}</span>` : ''}
                </div>
                ${PrintMenuProduct.configuration.showProductFeature ? featuresHtml : ''}
                ${PrintMenuProduct.configuration.showProductPrice ? `<span class="secondary-text" style="margin-left:auto; flex: 10%; text-align: right;"> ${this.getPrice()} </span>` : ''}
            </div>
        </div>
    </li>`;
    return html;
  }

  getPrice() {
    const currencyPosition = PrintMenuProduct.printCurrency.symbolPosition;
    const priceValues = this.price.map((price) => price).join(' / ');
    const currencySymbol = PrintMenuProduct.printCurrency.isActive ? PrintMenuProduct.printCurrency.symbol : '';

    if (currencyPosition === 'left') {
      return `${currencySymbol} ${priceValues}`;
    }
    return `${priceValues} ${currencySymbol}`;
  }

  getFeatures() {
    const size = this.featuresSize[PrintMenuProduct.configuration.featuresSize];
    return this.features.map((feature) => `    <img style="margin-right: 3px; margin-bottom: 2px; display: block" src="${feature}" alt="" width="${size}" height="${size}"/>`).join('\n            ');
  }

  static toInstance(props = {}) {
    return new PrintMenuProduct(props.guid, props.commercial_name, props.commercial_description,
      props.features, props.price, props.special, props.special_frame);
  }
}
